<video #videoRef [muted]="true"></video>
